<h1>{{ 'Turbo.Bookings.trailerHeightWarningDialog.lblHeadline2' | translate:'Warning! High trailer.' }}</h1>
<mat-dialog-content>
<t4-container>
  <div style="text-align: center">
    <img src="/images/Icons/256/TrailerHeightWarning.png" style="margin: 10px" />
    <p>{{ 'Turbo.Bookings.trailerHeightWarningDialog.lblMessage2' | translate:'This trailer has a total height of 270cm. Notify the customer of this and to be observant when passing low passages.' }}</p>
  </div>
</t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-xs-12" style="text-align: center">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="close()">{{ 'turbo.bookings.trailerHeightWarningDialog.cmdConfirm' | translate : 'Ok'}}</button>
  </div>
</mat-dialog-actions>
